<template :key="componentKey">
  <div>
    <v-row>
      <v-col cols="12">
        <BaseBlock
          title="Informations relatives à l'utilisations de données personnelles"
        >
          <v-container>
            <v-row>
              <v-col cols="12" md="12"
                >Les informations recueillies par cette application font l’objet
                d’un traitement par l’Université de Lille, l’Université de
                Picardie et le Conseil Régional de l’Ordre des Pharmaciens
                Hauts-de-France afin de gérer les demandes d’agrément de
                pharmaciens d’officine pour l’accueil d’étudiants en stage.
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12"
                >Sa base légale est l’intérêt légitime (RGPD, art. 6, 1., f) de
                ces trois institutions à mettre en place un tel traitement.
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12">
                Ce dispositif fait l’objet d’une convention de co-traitance de
                données personnelles précisant plus particulièrement les
                caractéristiques des traitements concernés et les rôles de
                chacune des parties.
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12">
                Les données collectées seront communiquées aux seuls
                destinataires suivants: <br /><span class="l-spaced"
                  >• les membres habilités du personnel de l’Université de Lille
                  et de l’Université de Picardie Jules Verne;</span
                >
                <br /><span class="l-spaced"
                  >• les membres habilités du Conseil Régional de l’Ordre des
                  Pharmaciens Hauts-de-France;</span
                >
                <br /><span class="l-spaced"
                  >• les membres de la Commission Régionale d’Agrément.</span
                >
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12">
                Les données sont conservées selon les règles suivantes:
                <br /><span class="l-spaced"
                  >• Pour les demandes faisant l’objet d’un agrément: 5 ans,
                  reconductibles si l’agrément fait l’objet d’un
                  renouvellement.</span
                >
                <br /><span class="l-spaced"
                  >• Pour les demandes n’ayant pas fait l’objet d’un agrément:
                  jusqu’à la deuxième session suivant le dépôt de la
                  demande.</span
                >
                <br /><span class="l-spaced"
                  >• Pour les dossiers incomplets: 3 mois.</span
                >
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12"
                >Au-delà, ces données sont susceptibles d’être archivées sur un
                support distinct et à accès limité, conformément aux règles
                applicables en matière d'archives publiques et d'archives
                privées.
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12"
                >Vous pouvez accéder aux données vous concernant, les rectifier,
                demander leur effacement ou exercer votre droit à la limitation
                du traitement de vos données. Vous pouvez également vous opposer
                au traitement de vos données.
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12"
                >Pour exercer ces droits, pour toute question sur le présent
                traitement et pour recevoir communication de la convention de
                co-traitance signée par les parties, vous pouvez contacter:
                <br /><span class="l-spaced"
                  >•
                  <a
                    target="_blank"
                    @click="
                      contact(
                        'pharma-agrement-officine--at--univ-lille--dot--fr'
                      )
                    "
                    >pharma-agrement-officine<span class="at"></span
                    >univ-lille<span class="dot"></span>fr</a
                  >
                  pour les candidats à l’agrément exerçant dans les départements
                  du Nord et du Pas-de-Calais ; </span
                ><br /><span class="l-spaced"
                  >•
                  <a
                    target="_blank"
                    @click="
                      contact('pharmacie.agrements--at--u-picardie--dot--fr')
                    "
                    >pharmacie.agrements<span class="at"></span>u-picardie<span
                      class="dot"
                    ></span
                    >fr</a
                  >
                  pour les candidats à l’agrément exerçant dans le département
                  de Picardie.</span
                >
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12"
                >Si vous estimez, après nous avoir contactés, que vos droits
                &#171; Informatique et Libertés &#187; ne sont pas respectés,
                vous pouvez adresser une réclamation à la
                <a href="http://www.cnil.fr" target="_blank">CNIL</a>.
              </v-col>
            </v-row>
          </v-container>
        </BaseBlock>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import BaseBlock from "@/components/base/BaseBlock";

export default {
  name: "DonneesPersonnelles",
  components: { BaseBlock },
  data: () => ({}),
  methods: {
    contact: function(e) {
      e = e.replace("--at--", "@");
      e = e.replace("--dot--", ".");
      var contact = document.createElement("a");
      contact.href = "mailto:" + e;
      contact.click();
      contact.remove();
    }
  }
};
</script>

<style>
.l-spaced {
  margin-left: 15px;
}
.at:before {
  content: "@";
}
.dot:before {
  content: ".";
}
</style>
